import { Link } from "react-router-dom";
import { Sparkle, ArrowRight } from "@phosphor-icons/react";

/**
 * FarmersIntroCard — the short editorial intro to Farmers Pulse.
 * Rendered on `/farmers` and `/farmers/mine` beneath the tab strip.
 * "Read more" links to the full article at `/farmers/about`.
 */
export default function FarmersIntroCard() {
  return (
    <section
      data-testid="farmers-intro-card"
      className="relative overflow-hidden rounded-3xl border border-black/10 bg-gradient-to-br from-[#FBF2E1] via-white to-[#F5EBDC] p-6 md:p-10"
    >
      <div className="absolute -top-16 -right-16 h-56 w-56 rounded-full bg-[color:var(--np-brand,#B85F2A)]/10 blur-3xl" />
      <div className="relative">
        <div className="font-mono-tech text-[10px] tracking-[0.4em] uppercase text-[color:var(--np-brand,#B85F2A)] flex items-center gap-2">
          <Sparkle size={12} weight="fill" /> / Farmers Pulse
        </div>
        <h2 className="mt-3 font-serif-display text-3xl md:text-4xl lg:text-5xl leading-[0.98] tracking-tight max-w-3xl">
          Listening to the Land. Learning from Each Other. Growing for the Future.
        </h2>
        <div className="mt-5 space-y-4 max-w-3xl font-serif-display text-base md:text-lg leading-relaxed text-[#2A2724]">
          <p className="italic text-[#3A3830]">Every farmer watches nature.</p>
          <p>
            The arrival of rain, the condition of the soil, the first flower on a plant, the appearance of
            an unfamiliar insect, the level of water in a well, the behavior of birds, an unusually hot
            afternoon, or the timing of a harvest can all tell a story.
          </p>
          <p>
            For generations, farmers have learned to read these signals. Today, as weather patterns shift
            and agriculture faces new challenges, these local observations are more valuable than ever.
          </p>
          <p>
            Farmers Pulse, a part of NaturePulse, is being created as a worldwide platform where farmers,
            growers, gardeners, agricultural experts, researchers and communities can observe, document,
            learn and share what is happening on the land around them.
          </p>
        </div>
        <div className="mt-6 flex flex-wrap items-center gap-3">
          <Link
            to="/farmers/about"
            data-testid="farmers-intro-readmore"
            className="inline-flex items-center gap-1.5 rounded-full bg-[#1B4332] text-[#F5EBDC] px-4 py-2 font-mono-tech text-[10px] tracking-[0.28em] uppercase hover:opacity-90"
          >
            Read more <ArrowRight size={11} weight="bold" />
          </Link>
          <span className="font-mono-tech text-[10px] tracking-[0.28em] uppercase text-[#3A3830]">
            Observe · Record · Learn · Share · Grow
          </span>
        </div>
      </div>
    </section>
  );
}
